import { SiteUrls } from '@tableau/shared-urls';

import { IContentInfo } from '../../../spacesPlatform/models/IContentInfo';


// Create an appropriate URL for a particular content type.
export function urlForContentType(siteUrls: SiteUrls, info: IContentInfo): string | null {
  switch (info.contentType) {
    case 'datasource':
      return siteUrls.datasourceUrl(info.id);
    case 'flow':
      return siteUrls.flowUrl(info.id);
    case 'database':
      return siteUrls.catalogDatabaseUrl(info.id);
    case 'table':
      return siteUrls.catalogTableUrl(info.id);
    case 'virtualConnection':
      return siteUrls.virtualConnectionUrl(info.id);
    case 'virtualConnectionTable':
      return siteUrls.virtualConnectionTableUrl(info.id);
    default:
      return null;
  }
}
